import React, { Component } from "react";
import { DKLabel, isEmpty } from "deskera-ui-library";
import {
    COLUMN_CODE,
    TableManger,
    TABLES,
} from "../../../managers/TableManger";
import Table from "../../../services/table";
import { getDashboardWidgetLoading } from "../../dashboard/Dashboard";
import { toCurrencyFormat } from "../../../utility/Utility";
import RouteManager from "../../../managers/RouteManager";
import { commonCustomEvent, COMMON_EVENTS } from "../../../services/event/commonEvents";
import JobPipelineService from "./JobPipeline";

interface IDealCardProps {
    onCountUpdated: (count: number) => void;
}
interface IDealCardState {
    data: any[];
    showLoading: boolean;
}
class JobPipelineCard extends Component<IDealCardProps, IDealCardState> {
    columnsIds = {
        name: "",
        status: "",
        amount: "",
    };
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showLoading: false,
        };
    }
    componentDidMount() {
        this.setColumnsIds();
        this.fetchRecords();
        document.addEventListener(COMMON_EVENTS.ADD_NEW_REC, (data) => this.onNewRecordAdd(data));
    }
    onNewRecordAdd = (data) => {
        if (data.detail.tableName === TABLES.JOB_PIPELINE) this.fetchRecords();
    }
    componentWillUnmount() {
        document.removeEventListener(COMMON_EVENTS.ADD_NEW_REC, (data) => this.onNewRecordAdd(data));
    }
    render() {
        return (
            <>
                {this.state.showLoading && getDashboardWidgetLoading()}
                {
                    <>
                        {!this.state.showLoading && this.state.data.length !== 0 && (
                            <>
                                <DKLabel
                                    text="Recently added"
                                    className="text-gray fw-m mb-r"
                                />
                                {this.state.data.map((record) => this.getRow(record))}
                            </>
                        )}
                    </>
                }
                {!this.state.showLoading &&
                    this.state.data.length === 0 &&
                    this.getEmptyState()}
            </>
        );
    }

    getRow(data) {
        return (
            <div
                className="row pt-s pb-r justify-content-between listPickerBG cursor-hand"
                onClick={() => {
                    JobPipelineService.selectedPielineId = data.id;
                    RouteManager.navigateToPage("/job-pipeline");
                }}
            >
                <div>
                    <div className="row">
                        <div className="column">
                            <div className="row">
                                <DKLabel
                                    text={`${data['name']}`}
                                    className="fw-m"
                                />
                                {!isEmpty(data[this.columnsIds.status]) &&
                                    data[this.columnsIds.status] !== 0 && (
                                        <DKLabel
                                            className={`ml-r p-v-xs p-h-s border-radius-l
                    ${data[this.columnsIds.status] === 1
                                                    ? "bg-chip-green text-green border-green"
                                                    : "bg-chip-red text-red border-red"
                                                }`}
                                            text={data[this.columnsIds.status] === 1 ? "Won" : "Lost"}
                                        />
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <DKLabel
                    text={`${data[this.columnsIds.amount]
                            ? toCurrencyFormat(data[this.columnsIds.amount])
                            : toCurrencyFormat(0)
                        }`}
                    className="fw-m fs-m text-dark-gray"
                /> */}
            </div>
        );
    }
    fetchRecords() {
        const dealTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
        Table.getRecordsByPage({ pageNo: 1, pageSize: 10 }, null, dealTableId).then(
            (res: any) => {
                JobPipelineService.pipelineData = res.data;
                if (this.props.onCountUpdated)
                    this.props.onCountUpdated(res.totalCount);
                this.setState({
                    data: JobPipelineService.getPipelineData(res.data),
                    // res.data.map((record) => {
                    //     let cells = record.cells;
                    //     cells.id = record._id;
                    //     return cells;
                    // }),
                    showLoading: false,
                });
            }
        );
    }

    setColumnsIds = () => {
        this.columnsIds.name = TableManger.getColumnId(
            TABLES.JOB_PIPELINE,
            COLUMN_CODE.JOB_PIPELINE.NAME
        );
        // this.columnsIds.amount = TableManger.getColumnId(
        //     TABLES.JOB_PIPELINE,
        //     COLUMN_CODE.JOB_PIPELINE.AMOUNT
        // );
        // this.columnsIds.status = TableManger.getColumnId(
        //     TABLES.JOB_PIPELINE,
        //     COLUMN_CODE.JOB_PIPELINE.STATUS
        // );
    };
    getEmptyState = () => {
        return (
            <div
                className={`column parent-width parent-height align-items-center justify-content-center`}
            >
                <DKLabel text="No data found" className="fw-m fs-m text-gray" />
                <DKLabel
                    text="Create your first interview pipeline now"
                    className="text-gray mt-xs"
                />
            </div>
        );
    };
}

export default JobPipelineCard;
